import { render, staticRenderFns } from "./UpdateEstimationArrival.vue?vue&type=template&id=21e6c8e9"
import script from "./UpdateEstimationArrival.vue?vue&type=script&lang=ts"
export * from "./UpdateEstimationArrival.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports